
const TokenKey = 'ui'

export function getToken() {
  const userInfo = localStorage.getItem(TokenKey)
  return userInfo ? JSON.parse(userInfo) : ''
}

export function setToken(userInfo) {
  localStorage.setItem(TokenKey, JSON.stringify(userInfo))
}

export function removeToken() {
  localStorage.removeItem(TokenKey)
}
